export const en = {
    active: 'Accepted',
    archived: 'Archived',
    'completed-by-client': 'Rejected by agency',
    'completed-by-date': 'Completed by date',
    'completed-by-publisher': 'Canceled by publisher',
    'preferred-deal': 'Preferred deal',
    private_marketplace: 'Private auction',
    received: 'Received'
};
